module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG4d9f26274cf33e0e93e13e71cc910b70.4d9f2627.png";